import Tag from '@/shared/Tags/Tag'
import systemEventsUtils from '../../systemEvents.utils.ts'
import { ISystemEvent } from '../../systemEvents.types.ts'

interface IProps {
  notification: ISystemEvent
}

const SystemEventTypeTag = (props: IProps) => {
  switch (props.notification.type) {
    case 'ALARM_SITUATION_INCIDENT':
      return (
        <Tag color="orange">
          <p className="text-sm" style={{ color: 'inherit' }}>
            {systemEventsUtils.getTypeText(props.notification.type)}
          </p>
        </Tag>
      )
    case 'LP_ERROR':
      return (
        <Tag color={props.notification.payload.flag === 'WARNING' ? 'orange' : 'red'}>
          <p className="text-sm" style={{ color: 'inherit' }}>
            {props.notification.payload.flag === 'WARNING' ? 'Предупреждение лифта' : 'Ошибка лифта'}
          </p>
        </Tag>
      )
    case 'MOVED_TO_MAINTENANCE':
    case 'MOVED_FROM_MAINTENANCE_TO_NORMAL':
      return (
        <Tag color="geekblue">
          <p className="text-sm" style={{ color: 'inherit' }}>
            {systemEventsUtils.getTypeText(props.notification.type)}
          </p>
        </Tag>
      )
    default:
      return (
        <Tag color="gray">
          <p className="text-sm" style={{ color: 'inherit' }}>
            {systemEventsUtils.getTypeText(props.notification.type)}
          </p>
        </Tag>
      )
  }
}

export default SystemEventTypeTag
